import '../../../../../../../components/skeletons/skeleton.css'
import { RECOMMENDATION_FUNDS_SECTION_INSET_PX } from '../funds/RecommendationFundsSectionTitle'
import {
  PLAN_RECOMMENDATION_INTRO_BY_PLAN_MODE,
  type PlanRecommendationIntroPlanMode
} from './PlanRecommendationIntro'

export function PlanRecommendationSheetSkeleton({
  planMode,
  detailsTitle
}: {
  planMode: PlanRecommendationIntroPlanMode
  detailsTitle: string
}) {
  return (
    <div className="pb-2">
      <PlanRecommendationIntroSkeleton planMode={planMode} />
      <PlanRecommendationHeaderSkeleton />
      <PlanRecommendationBodySkeleton detailsTitle={detailsTitle} />
    </div>
  )
}

export function PlanRecommendationIntroSkeleton({
  planMode
}: {
  planMode: PlanRecommendationIntroPlanMode
}) {
  const intro = PLAN_RECOMMENDATION_INTRO_BY_PLAN_MODE[planMode]

  return (
    <div className="px-5">
      <div className="flex flex-col gap-2">
        <div
          className="text-[14px] font-[500] leading-[130%]"
          style={{ color: intro.color }}
        >
          {intro.label}
        </div>
        <div className="skeleton h-[52px] w-full max-w-[85%] rounded-[4px]" />
      </div>
    </div>
  )
}

export function PlanRecommendationHeaderSkeleton() {
  return (
    <div className="pt-9 pb-4">
      <RecommendationFundsSectionSkeleton />
      <RecommendationFundsSectionSkeleton sectionClassName="pt-8" />
    </div>
  )
}

export function PlanRecommendationBodySkeleton({ detailsTitle }: { detailsTitle: string }) {
  return (
    <>
      <div className="mt-6 h-[10px] bg-[#F0F4F7]" />
      <div className="bg-white pt-5">
        <div className="px-5 pb-6 pt-2 text-[18px] font-[500] leading-[130%] text-[#232323]">
          {detailsTitle}
        </div>
        <div className="flex gap-4 px-5">
          <div className="skeleton h-[80px] w-16 shrink-0 rounded-[4px]" />
          <div className="skeleton h-[80px] w-16 shrink-0 rounded-[4px]" />
          <div className="skeleton h-[80px] w-16 shrink-0 rounded-[4px]" />
        </div>
      </div>
      <div className="flex flex-col gap-3 px-5 pb-2 pt-4">
        <div className="skeleton h-[52px] w-full rounded-[12px]" />
        <div className="skeleton h-[52px] w-full rounded-[12px]" />
        <div className="skeleton h-[52px] w-full rounded-[12px]" />
      </div>
    </>
  )
}

function RecommendationFundsSectionSkeleton({
  sectionClassName = ''
}: {
  sectionClassName?: string
}) {
  return (
    <div className={sectionClassName}>
      <div
        className="flex items-center justify-between gap-3 pr-5 pb-3"
        style={{ paddingInlineStart: RECOMMENDATION_FUNDS_SECTION_INSET_PX }}
      >
        <div className="flex min-w-0 items-center gap-2">
          <div className="skeleton h-[14px] w-[14px] shrink-0 rounded-[4px]" />
          <div className="skeleton h-[14px] w-[108px] rounded-[4px]" />
        </div>
      </div>
      <div className="w-full pr-5" style={{ paddingInlineStart: RECOMMENDATION_FUNDS_SECTION_INSET_PX }}>
        <div className="skeleton h-[160px] w-full rounded-[12px]" />
      </div>
    </div>
  )
}
